import React, { useEffect, useState } from "react";
import { storage } from "../firebase/fireInit";
import PickImageImage from "../misc/elements/PickImageImage";
import SimpleFieldInput from "./SimpleFieldInput";
import { getDownloadURL } from "firebase/storage";
import { ref } from "firebase/storage";
import RatingInput from "./RatingInput";

// name of the rating
const CreateRatingInput = ({
  onEnter,
  inputRef,
  icon,
  name,
  hint,
  personalName,
  personalHint,
  field,
  onRatingInputChange,
}) => {
  const [ratingObject, setRatingObject] = useState({});
  const [personalRating, setPersonalrating] = useState(null);

  useEffect(() => {
    onRatingInputChange(ratingObject, personalRating, field);
  }, [ratingObject, personalRating]);

  useEffect(() => {
    setRatingObject({ name, hint, icon });
    setPersonalrating({ name: personalName, hint: personalHint });
  }, []);

  function onIconChanged(path) {
    getDownloadURL(ref(storage, path)).then((url) => {
      setRatingObject({ ...ratingObject, icon: url });
    });
  }
  function onInputChange(value, field) {
    setRatingObject({ ...ratingObject, [field]: value });
  }

  function onPersonalChange(value, field) {
    setPersonalrating({ ...personalRating, [field]: value });
  }
  return (
    <div
      className="divColumn"
      style={{ width: "100%", justifyContent: "center" }}
    >
      <div
        className="divRow"
        style={{ width: "100%", justifyContent: "space-around" }}
      >
        <div className="divRow">
          <div
            className="textBoldWhite"
            style={{
              paddingLeft: "5px",
              paddingRight: "5px",
              flexDirection: "column",
              height: "26px",
              backgroundColor: "#6f6f6f",
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            Name the Rating
          </div>
          <RatingInput
            value={ratingObject.name}
            onChange={onInputChange}
            field="name"
            width="180px"
            hint="name"
            maxLength={20}
          />
        </div>

        <PickIcon onIconChanged={onIconChanged} />
      </div>
      <div className="divRow" style={{ marginTop: "10px" }}>
        <div
          className="textBoldWhite"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
            flexDirection: "column",
            height: "26px",
            backgroundColor: "#6f6f6f",
            display: "flex",
            fontSize: "12px",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          Describe in short what is getting rated
        </div>
        <RatingInput
          value={ratingObject.hint}
          onChange={onInputChange}
          field="hint"
          width="400px"
          hint="description"
          maxLength={100}
        />
      </div>
      {personalRating?.name != null && (
        <PersonalRatings
          personalRating={personalRating}
          onPersonalChange={onPersonalChange}
        />
      )}
    </div>
  );
};

const PersonalRatings = ({ personalRating, onPersonalChange }) => {
  return (
    <div
      className="divColumn"
      style={{
        width: "100%",
        backgroundColor: "#4f4f4f",
        marginTop: "10px",
        borderRadius: ".5rem/.5rem",
      }}
    >
      <div className="textBoldWhite">Personal Rating</div>
      <div className="divRow">
        <div
          className="textBoldWhite"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
            flexDirection: "column",
            height: "26px",
            backgroundColor: "#6f6f6f",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          Name of the rating for singular user
        </div>
        <RatingInput
          value={personalRating.name}
          onChange={onPersonalChange}
          field="name"
          width="180px"
          hint="name"
          maxLength={20}
        />
      </div>
      <div className="divRow" style={{ marginTop: "10px" }}>
        <div
          className="textBoldWhite"
          style={{
            paddingLeft: "5px",
            paddingRight: "5px",
            flexDirection: "column",
            height: "26px",
            backgroundColor: "#6f6f6f",
            display: "flex",
            fontSize: "12px",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          Description when rating personally
        </div>
        <RatingInput
          value={personalRating.hint}
          onChange={onPersonalChange}
          field="hint"
          width="400px"
          hint="description"
          maxLength={100}
        />
      </div>
    </div>
  );
};

const PickIcon = ({ onIconChanged }) => {
  return (
    <div
      className="divRow"
      style={{
        backgroundColor: "#2f2f2f",
        padding: "5px",
        borderRadius: ".5rem/.5rem",
        paddingRight: "10px",
      }}
    >
      <div className="textBoldWhite" style={{ marginRight: "10px" }}>
        Pick Icon
      </div>
      <PickImageImage
        size="30px"
        storagePath={"boxTypes/icons/"}
        onImageChanged={onIconChanged}
      />
    </div>
  );
};
export default CreateRatingInput;
